namespace GeniuzPOS.Product {
    export class SkuHdColumns {
        static columnsKey = 'Product.SkuHd';
    }
}
